import { controller } from "./controller";

@controller
export default class ClosePopupButtonElement extends HTMLElement {
  close(): void {
    const popupId = this.getAttribute("ref");
    if (popupId) {
      const elm: HTMLElement | null = document.querySelector(`[data-popup-id="${popupId}"]`);
      if (elm) {
        elm.style.display = "none";
      }
    }
  }

  open(): void {
    const popupId = this.getAttribute("ref");
    if (popupId) {
      const elm: HTMLElement | null = document.querySelector(`[data-popup-id="${popupId}"]`);
      if (elm) {
        elm.style.display = "block";
      }
    }
  }
}

declare global {
  interface Window {
    ClosePopupButtonElement: typeof ClosePopupButtonElement;
  }
  interface HTMLElementTagNameMap {
    "popup-button": ClosePopupButtonElement;
  }
}

if (!window.customElements.get("popup-button")) {
  window.ClosePopupButtonElement = ClosePopupButtonElement;
  window.customElements.define("popup-button", ClosePopupButtonElement);
}
